'use client';

import {
  MediaKitButton,
  SearchWithDownload,
} from '@web-landing/components/StrapiHeader/RightSideContent';
import {
  onLinkClickProps,
  StrapiHeaderProps,
} from '@web-landing/components/StrapiHeader/StrapiHeader.types';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';
import {emitYmEvent} from '@web-landing/analytics/helpers/ymEvent';

import {Header} from '@packages/ui-kit/src/Header';

import {EVENTS} from '@web-landing/analytics/events';

export default function HeaderComponent({
  links,
  logo,
  mobileMenu,
  anchorLinks,
  requestUrl,
  page,
  cookieDomain,
  mediaKitLink,
  scaleLogo,
  searchButtonText = 'Поиск',
  downloadButtonText = 'Скачать RuStore',
}: StrapiHeaderProps) {
  const onLinkClick = (props: onLinkClickProps) => {
    switch (props.title) {
      case 'Разработчикам':
        emitYmEvent('header_menu_button_developers');
        logTmrEvent(EVENTS.headerLinkClick_devs);

        break;

      case 'Игры':
        emitYmEvent('header_menu_button_games');

        logTmrEvent(EVENTS.headerLinkClick_games);

        break;

      case 'Помощь':
        emitYmEvent('header_menu_button_help');

        logTmrEvent(EVENTS.headerLinkClick_help);

        break;

      case 'Приложения':
        emitYmEvent('header_menu_button_apps');

        logTmrEvent(EVENTS.headerLinkClick_apps);

        break;
    }

    logTmrEvent(EVENTS.headerLinkClick, {button_text: props.title});
  };

  const onAnchorClick = (props: onLinkClickProps) => {
    logTmrEvent(EVENTS.mediaKitHeaderClick, {button_text: props.title});
  };

  const rightSideContentMap: Record<
    typeof page,
    ({isTopScroll}: {isTopScroll: boolean}) => React.ReactNode
  > = {
    main: ({isTopScroll}) => (
      <SearchWithDownload
        requestUrl={requestUrl}
        isTopScroll={isTopScroll}
        cookieDomain={cookieDomain}
        downloadButtonText={downloadButtonText}
        searchButtonText={searchButtonText}
      />
    ),
    'media-kit': ({isTopScroll}) => (
      <MediaKitButton isTopScroll={isTopScroll} href={mediaKitLink} />
    ),
  };

  const rightSideContent = rightSideContentMap[page];
  return (
    <Header
      mobileMenu={{mobileMenuTitle: mobileMenu.mobileMenuTitle}}
      links={links}
      logo={{...logo, href: '/'}}
      anchorLinks={anchorLinks}
      rightSideContent={rightSideContent}
      onLinkClick={onLinkClick}
      onAnchorLinkClick={onAnchorClick}
      scaleLogo={scaleLogo}
    />
  );
}
